// KnowledgeGraphVisualization.jsx
import React from 'react';

const KnowledgeGraphVisualization = ({ onNodeSelect }) => {
  // Sample nodes data for demonstration
  const nodes = [
    { id: 'braf', name: 'BRAF V600E', type: 'mutation', x: 300, y: 200, color: '#e74c3c' },
    { id: 'vemurafenib', name: 'Vemurafenib', type: 'drug', x: 150, y: 100, color: '#3498db' },
    { id: 'dabrafenib', name: 'Dabrafenib', type: 'drug', x: 450, y: 100, color: '#3498db' },
    { id: 'encorafenib', name: 'Encorafenib', type: 'drug', x: 150, y: 300, color: '#3498db' },
    { id: 'mapk', name: 'MAPK', type: 'pathway', x: 225, y: 350, color: '#2ecc71' },
    { id: 'erk', name: 'ERK', type: 'pathway', x: 375, y: 350, color: '#2ecc71' },
    { id: 'resistance', name: 'Resistance', type: 'outcome', x: 450, y: 300, color: '#9b59b6' }
  ];

  // Sample node data for when a node is clicked
  const nodeData = {
    'braf': {
      name: "BRAF V600E Mutation",
      type: "mutation",
      definition: "Substitution at position 600 in the BRAF gene, changing valine (V) to glutamic acid (E)",
      evidence: { trials: 14, papers: 86, guidelines: 3 },
      treatments: ["Dabrafenib", "Vemurafenib", "Encorafenib"]
    },
    'vemurafenib': {
      name: "Vemurafenib",
      type: "drug",
      definition: "BRAF inhibitor used in treatment of melanoma with BRAF V600E mutation",
      evidence: { trials: 8, papers: 42, guidelines: 2 },
      treatments: []
    },
    // Other nodes data would be defined similarly
  };

  const handleNodeClick = (nodeId) => {
    if (onNodeSelect && nodeData[nodeId]) {
      onNodeSelect(nodeData[nodeId]);
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <svg width="100%" height="400" viewBox="0 0 600 400">
        {/* Connection lines */}
        <line x1="300" y1="200" x2="150" y2="100" stroke="#999" strokeWidth="2" />
        <line x1="300" y1="200" x2="450" y2="100" stroke="#999" strokeWidth="2" />
        <line x1="300" y1="200" x2="150" y2="300" stroke="#999" strokeWidth="2" />
        <line x1="300" y1="200" x2="450" y2="300" stroke="#999" strokeWidth="2" />
        <line x1="300" y1="200" x2="225" y2="350" stroke="#999" strokeWidth="2" />
        <line x1="300" y1="200" x2="375" y2="350" stroke="#999" strokeWidth="2" />
        <line x1="450" y1="100" x2="450" y2="300" stroke="#999" strokeWidth="2" strokeDasharray="5,5" />
        
        {/* Nodes */}
        {nodes.map(node => (
          <g key={node.id} onClick={() => handleNodeClick(node.id)} style={{cursor: 'pointer'}}>
            <circle cx={node.x} cy={node.y} r={node.type === 'mutation' ? 40 : 30} fill={node.color} />
            <text x={node.x} y={node.y} textAnchor="middle" fill="white" fontWeight={node.type === 'mutation' ? 'bold' : 'normal'}>
              {node.name}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
};

export default KnowledgeGraphVisualization;